import React from "react";
export const CheckCircle = () => (
  <svg viewBox="0 0 14 16">
    <path d="M7 1.18C3.32 1.18.33 4.17.33 7.85S3.32 14.51 7 14.51s6.67-2.99 6.67-6.67S10.68 1.18 7 1.18zM5.19 10.7L2.8 8.31a.664.664 0 11.94-.94l1.93 1.92 4.59-4.59a.664.664 0 11.94.94L6.13 10.7c-.25.26-.68.26-.94 0z" />
  </svg>
);
